import moment from 'moment';
import { Alert } from '../web/react-native';
import { ControlType } from '../services/dataModels';

export function isDateBeforeToday(date) {
  return new Date(date.toDateString()) < new Date(new Date().toDateString());
}

export function formatControlValue(controlType: ControlType, controlValue: string) {
  if (!controlValue) {
    return;
  }

  const date = Date.parse(controlValue) && moment.utc(controlValue).local().toDate();

  switch (controlType.toLocaleLowerCase()) {
    case 'date':
      return `${date ? date.toLocaleDateString('en-US') : controlValue}`;
    case 'time':
      return moment.utc(controlValue, 'HH:mm:ss').local().format('hh:mm A');
    case 'datetime':
      return date
        ? `${date.toLocaleDateString('en-US')} ${date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
          })}`
        : controlValue;
    default:
      return controlValue;
  }
}

interface AlertParameters {
  title: string;
  description: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onOk?: () => void;
}

export function displayConfirmationAlert({
  title,
  description,
  onConfirm,
  onCancel,
}: Omit<AlertParameters, 'onOk'>): void {
  Alert.alert(title, description, [
    {
      text: 'CANCEL',
      style: 'cancel',
      onPress: onCancel,
    },
    {
      text: 'YES',
      onPress: onConfirm,
    },
  ]);
}

export function displayInformationAlert({
  title,
  description,
  onOk,
}: Omit<AlertParameters, 'onConform' | 'onCancel'>): void {
  Alert.alert(title, description, [
    {
      text: 'OK',
      onPress: onOk,
    },
  ]);
}
